import {
	RiBookOpenLine,
	RiBracesLine,
	RiInstanceLine,
	RiKey2Line,
	RiLoginBoxLine,
} from '@remixicon/react';
import { type ReactNode } from 'react';

import {
	Navigation,
	type NavigationVariant,
} from '@shared/compositions/navigation';

import * as routes from '@portal/pkg/routes';
import { useSession } from '@portal/pkg/session';
import { AccountMenu } from '@portal/views/_shared/navigation/AccountMenu';

interface PortalNavigationProps {
	variant?: NavigationVariant;
}

export function PortalNavigation({
	variant,
}: PortalNavigationProps): ReactNode {
	const { status } = useSession();

	const icon: ReactNode = <RiInstanceLine />;

	const signedIn = status === 'authenticated';

	const mainNavigationItems = [
		{
			href: routes.Docs('getting-started'),
			label: 'Documentation',
			leadingIcon: <RiBookOpenLine />,
		},
		{
			href: routes.Reference(),
			label: 'Reference',
			leadingIcon: <RiBracesLine />,
		},
	];

	if (signedIn) {
		mainNavigationItems.push({
			href: routes.Keys(),
			label: 'Manage keys',
			leadingIcon: <RiKey2Line />,
		});
	}

	const primaryAction = signedIn
		? undefined
		: {
				href: routes.Login(),
				label: 'Sign in',
				trailingIcon: <RiLoginBoxLine />,
			};

	return (
		<Navigation
			displayName="Developer Portal"
			logotype={icon}
			variant={variant}
			rootPath={routes.Home()}
			renderActionsWith={signedIn ? <AccountMenu /> : undefined}
			primaryAction={primaryAction}
			items={mainNavigationItems}
		/>
	);
}
